import AddIcon from "@mui/icons-material/Add";
import {
    Accordion, AccordionDetails, AccordionSummary,
    Button, Checkbox,
    CircularProgress,
    Collapse,
    Dialog,
    DialogContent,
    DialogTitle, FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    MenuItem,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import {Box} from "@mui/system";
import React, {useEffect, useState} from "react";
import {useGetCalendarEvent} from "../../hooks/data/data_calendar";
import {customFetcher, getFetch, useFetch} from "../../hooks/useFetch";
import {IAddressType} from "../../interfaces/IAddress";
import {IBillState} from "../../interfaces/IBillState";
import {IContractState} from "../../interfaces/IContractState";
import {IContractType} from "../../interfaces/IContractType";
import {ICustomer} from "../../interfaces/ICustomer";
import {IGender} from "../../interfaces/IGender";
import {IHandoverProtocol} from "../../interfaces/IHandoverProtocol";
import {IInsurance} from "../../interfaces/IInsurance";
import {IMaterial} from "../../interfaces/IMaterial";
import {IMaterialCategory} from "../../interfaces/IMaterialCategory";
import {IMaterialDocument} from "../../interfaces/IMaterialDocument";
import {IMaterialSubcategory} from "../../interfaces/IMaterialSubcategory";
import {IMIMEType} from "../../interfaces/IMIMEType";
import {IOffer} from "../../interfaces/IOffer";
import {IOfferState} from "../../interfaces/IOfferState";
import {IOfferType} from "../../interfaces/IOfferType";
import {IPartner} from "../../interfaces/IPartner";
import {IProject} from "../../interfaces/IProject";
import {IProjectNote} from "../../interfaces/IProjectNote";
import {IProjectParticipant} from "../../interfaces/IProjectParticipant";
import {IProjectState} from "../../interfaces/IProjectState";
import {IPropertyManagment} from "../../interfaces/IPropertyManagement";
import {IReasonCancellation} from "../../interfaces/IReasonCancellation";
import {IService} from "../../interfaces/IService";
import {IServiceCategory} from "../../interfaces/IServiceCategory";
import {ISystemMail} from "../../interfaces/ISystemMail";
import {ITemplate} from "../../interfaces/ITemplate";
import {ITitle} from "../../interfaces/ITitle";
import {IUnit} from "../../interfaces/IUnit";
import {IProfile} from "../../interfaces/IUser";
import {IWorker} from "../../interfaces/IWorker";
import {AddressEdit} from "../address/AddressEdit";
import {ContractTab} from "../Contract/ContractTab";
import {CustomeTextField} from "../core/CustomeTextField";
import {MapSearch} from "../core/MapSearch";
import {ParticipantsTable} from "../customer/Childs/ParticipantsTable";
import {WorkerTable} from "../customer/Childs/WorkerTable";

import {HandoverProtocolTable} from "../handoverProtocol/HandoverProtocolTable";
import {OfferTable} from "../offer/OfferTable";
import {getInnendienstRelationship} from "../user/ProfileInnendienstAssignment";
import ProjectEditWorkerAssignmentStepper from "./ProjectEditWorkerAssignmentStepper";
import {ProjectLogTab} from "./ProjectLogTab";
import {ProjectNoteTable} from "./projectNote/ProjectNoteTable";
import CalendarMain from "../calendar/CalendarMain";
import {CheckListTab} from "../checkList/CheckListTab";
import {InvoiceTab} from "../invoice/InvoiceTab";
import {IInvoiceState} from "../../interfaces/IInvoiceState";
import {IInvoiceType} from "../../interfaces/IInvoiceType";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useGetOfferByProject} from "../../hooks/data/data_offer";
import EditIcon from '@mui/icons-material/Edit';
import {useGetLeadQuellen} from "../../hooks/data/data_leadquelle";
import {useUpdateCustomer} from "../../hooks/data/data_customer";
import {a11yProps, CustomTabPanel} from "../core/CustomTabPanel";
import {DocumentTable} from "../documents/DocumentTable";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export const isInnendienstProjectWorker = (worker: IWorker | undefined) => {
    return [3, 4].includes(worker?.ProjectRole.id as number);
};

interface IProps {
    projectObject: IProject;
    setProjectObject: Function;
    projectStateArray: IProjectState[];
    reasonCancellationArray: IReasonCancellation[];
    genderArray: IGender[];
    academicTitleArray: ITitle[];
    customerArray: ICustomer[];
    setCustomerArray: Function;
    userArray: IProfile[];
    insuranceArray: IInsurance[];
    setInsuranceArray: Function;
    propertyManagementArray: IPropertyManagment[];
    setPropertyManagementArray: Function;
    unitArray: IUnit[];
    addressTypeArray: IAddressType[];
    serviceArray: IService[];
    templateArray: ITemplate[];
    serviceCategoryArray: IServiceCategory[];
    materialArray: IMaterial[];
    materialCategoryArray: IMaterialCategory[];
    materialSubcategoryArray: IMaterialSubcategory[];
    offerStateArray: IOfferState[];
    offerTypeArray: IOfferType[];
    partnerArray: IPartner[];
    billStateArray: IBillState[];
    mimeTypeArray: IMIMEType[];
    systemMailArray: ISystemMail[];
    materialDocumentArray: IMaterialDocument[] | undefined;
    contractTypeArray: IContractType[];
    contractStateArray: IContractState[];

    invoiceStates: IInvoiceState[];
    invoiceTypes: IInvoiceType[];
}

export const ProjectEdit: React.FC<IProps> = ({
                                                  projectObject,
                                                  setProjectObject,
                                                  projectStateArray,
                                                  reasonCancellationArray,
                                                  genderArray,
                                                  academicTitleArray,
                                                  customerArray,
                                                  setCustomerArray,
                                                  userArray,
                                                  insuranceArray,
                                                  setInsuranceArray,
                                                  propertyManagementArray,
                                                  setPropertyManagementArray,
                                                  unitArray,
                                                  addressTypeArray,
                                                  serviceArray,
                                                  templateArray,
                                                  serviceCategoryArray,
                                                  materialArray,
                                                  materialCategoryArray,
                                                  materialSubcategoryArray,
                                                  offerStateArray,
                                                  offerTypeArray,
                                                  partnerArray,
                                                  mimeTypeArray,
                                                  materialDocumentArray,
                                                  billStateArray,
                                                  systemMailArray,
                                                  contractTypeArray,
                                                  contractStateArray,
                                                  invoiceStates,
                                                  invoiceTypes,
                                              }) => {
    const idRole = Number(localStorage.getItem("idRole"));

    const [handoverProtocolArray, setHandoverProtocolArray] = useFetch<IHandoverProtocol[]>(
        "/handoverprotocol/byProject/",
        projectObject.id,
    );
    const {offers, isLoadingOfferByProject, refetechOfferByProject} = useGetOfferByProject(projectObject.id);
    const [offerArray, setOfferArray] = useState<IOffer[]>([]);
    useEffect(() => {
        if (offers) setOfferArray(offers);
    }, [offers]);
    useEffect(() => {
        setProjectObject({...projectObject, Offers: offerArray});
    }, [offerArray]);

    const {
        event: b_appointmentEvent,
        isLoading: loadingB,
        refetch: refetchB
    } = useGetCalendarEvent(projectObject.id_b_appointment);
    const {event: constructionEvent, isLoading: loadingC, refetch: refetchC} = useGetCalendarEvent(
        projectObject.id_construction_appointment,
    );

    const [isDocumentsWorking, setIsDocumentsWorking] = useState(false);
    const [openCalendar, setOpenCalendar] = useState(false);
    const [workerForCustomer, setWorkerForCustomer] = useState<IProfile>();
    const [showAssignWorkerDialog, setShowAssignWorkerDialog] = useState(false);
    const [is_b_appointment, setIs_b_appointment] = useState(false);
    const [is_construction_appointment, setIs_construction_appointment] = useState(false);
    const [customer, setCustomer] = useState<ICustomer[]>(customerArray);
    const [value, setValue] = React.useState(0);
    const [calendarEventId, setCalendarEventId] = useState<number | undefined>(undefined);


    const {updateCustomer, isPendingUpdateCustomer} = useUpdateCustomer();
    const {leadQuellen} = useGetLeadQuellen();

    const contactPersonParticipant = projectObject.Participant?.find((p) => p.is_contact_person);
    const contactPersonCustomerId = contactPersonParticipant?.Customer;

    const [contactCustomerObject, setContactCustomerObject] = useState<ICustomer | null>(null);

    useEffect(() => {
        if (contactPersonCustomerId) {
            getFetch<ICustomer>(`/customer/${contactPersonCustomerId}`, null, setContactCustomerObject);
        }
    }, [contactPersonCustomerId]);

    const b_appointmentDateTime = b_appointmentEvent?.startDate
        ? b_appointmentEvent.startDate.replace(" ", "T").slice(0, 16)
        : "";
    const construction_appointmentDateTime = constructionEvent?.startDate
        ? constructionEvent.startDate.replace(" ", "T").slice(0, 16)
        : "";

    const handleOpenCalendar = (appointmentType: string, eventId?: number) => {
        setCalendarEventId(eventId);
        if (appointmentType === "b_appointment") {
            setIs_b_appointment(true);
            setIs_construction_appointment(false);
        } else if (appointmentType === "construction_appointment") {
            setIs_b_appointment(false);
            setIs_construction_appointment(true);
        }
        setOpenCalendar(true);
    };

    const handleCloseCalendar = () => setOpenCalendar(false);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        if (isDocumentsWorking) {
            return;
        }
        setValue(newValue);
    };
    const assignWorkerForCustomer = (currentParticipantArray: IProjectParticipant[]) => {
        if (currentParticipantArray.length > 0) {
            //find the customer which is the contact person
            const contactPerson = currentParticipantArray.find((x) => x.is_contact_person);
            if (contactPerson) {
                const worker = projectObject.Worker.find((x) => x.ProjectRole.id === 6);
                if (worker) {
                    return;
                }
                if (!workerForCustomer) {
                    getFetch<IProfile>(
                        `/postcode/assignment/getUserForPostcodeByCustomerId/`,
                        contactPerson.Customer,
                        setWorkerForCustomer,
                    );
                } else if (workerForCustomer) {
                    if (!projectObject.Worker.find((x) => x.Profile.id === workerForCustomer.id)) {
                        setShowAssignWorkerDialog(true);
                    }
                }
            }
        }
    };

    const innendienstWorker =
        workerForCustomer && userArray.find((x) => x.id === getInnendienstRelationship(workerForCustomer)?.peer);

    const state = projectObject.ProjectState;
    const errors = {
        inquiry: state > 1 && !projectObject.date_inquiry,
        bTermin: state > 3 && !b_appointmentDateTime,
        baubeginn: state >= 6 && !construction_appointmentDateTime,
        abnahme: state > 9 && !projectObject.date_acceptance,
    };
    const hasErrors = Object.values(errors).some((e) => e);

    useEffect(() => {
        setCustomerArray(customer);
    }, [customer, setCustomerArray]);
    useEffect(() => {
        if (workerForCustomer) {
            //check if the worker is already assigned to the project
            const worker = projectObject.Worker.find((x) => x.Profile.id === workerForCustomer.id);
            if (!worker) {
                setShowAssignWorkerDialog(true);
            }
        }
    }, [workerForCustomer]);

    // ZENTRIERUNG DES AKTIVEN TABS BEI WECHSEL
    useEffect(() => {
        const activeTab = document.getElementById(`simple-tab-${value}`);
        if (activeTab?.scrollIntoView) {
            activeTab.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
    }, [value]);

    const handleEventChanged = (
        action: "created" | "updated" | "deleted",
        id: number
    ) => {
        const key = is_b_appointment ? "id_b_appointment" : "id_construction_appointment";
        if (action === "deleted") {
            // Termin gelöscht: ID entfernen
            setProjectObject({...projectObject, [key]: null});
        } else {
            // Termin erstellt oder aktualisiert: ID setzen
            setProjectObject({...projectObject, [key]: id.toString()});
            //Termin neu laden damit Sie im Projekt richtig angezeigt werden
            if (is_b_appointment) {
                refetchB();
            } else {
                refetchC();
            }
        }
        setOpenCalendar(false);
        setCalendarEventId(undefined);
    };


    const updateCustomerLeadQuelle = async (customer: ICustomer) => {
        try {
            await updateCustomer(customer);
        } catch (error) {
            console.error("Fehler beim Aktualisieren des Kunden:", error);
        }
    };

    return (
        <>
            <Dialog open={openCalendar} onClose={handleCloseCalendar} maxWidth="md" fullWidth>
                <DialogContent>
                    <CalendarMain
                        is_b_appointment={is_b_appointment}
                        is_construction_appointment={is_construction_appointment}
                        projectObject={projectObject}
                        initialEventId={calendarEventId}
                        onEventChanged={handleEventChanged}
                    />
                </DialogContent>
            </Dialog>


            <Dialog
                open={showAssignWorkerDialog}
                onClose={() => {
                    setShowAssignWorkerDialog(false);
                }}
                maxWidth="lg"
            >
                <DialogTitle>
                    <Typography variant="h5" component="div" sx={{fontWeight: "bold", color: "primary.main"}}>
                        Mitarbeiterzuweisung
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <ProjectEditWorkerAssignmentStepper
                        workerForCustomer={workerForCustomer}
                        innendienstWorker={innendienstWorker}
                        existingInnendienstWorkers={projectObject.Worker.filter(isInnendienstProjectWorker)?.map(
                            (worker) => worker.Profile,
                        )}
                        userInteractionComplete={(assignmentAction) => {
                            switch (assignmentAction) {
                                case "Aussendienst": {
                                    setProjectObject({
                                        ...projectObject,
                                        Worker: [
                                            ...projectObject.Worker,
                                            {
                                                Profile: workerForCustomer,
                                                ProjectRole: {
                                                    id: 6,
                                                    role: "Außendienst",
                                                },
                                            },
                                        ],
                                    });
                                    break;
                                }
                                case "BothReplaceInnendienst": {
                                    setProjectObject({
                                        ...projectObject,
                                        Worker: [
                                            ...projectObject.Worker.filter((x) => !isInnendienstProjectWorker(x)),
                                            {
                                                Profile: workerForCustomer,
                                                ProjectRole: {
                                                    id: 6,
                                                    role: "Außendienst",
                                                },
                                            },
                                            innendienstWorker && {
                                                Profile: innendienstWorker,
                                                ProjectRole: {
                                                    id: 4,
                                                    role: "Innendienst",
                                                },
                                            },
                                        ].filter(Boolean),
                                    });
                                    break;
                                }
                                case "BothAddInnendienst": {
                                    setProjectObject({
                                        ...projectObject,
                                        Worker: [
                                            ...projectObject.Worker,
                                            {
                                                Profile: workerForCustomer,
                                                ProjectRole: {
                                                    id: 6,
                                                    role: "Außendienst",
                                                },
                                            },
                                            innendienstWorker && {
                                                Profile: innendienstWorker,
                                                ProjectRole: {
                                                    id: 4,
                                                    role: "Innendienst",
                                                },
                                            },
                                        ].filter(Boolean),
                                    });
                                    break;
                                }
                            }
                            setShowAssignWorkerDialog(false);
                        }}
                    />
                </DialogContent>
            </Dialog>

            <Grid container spacing={2} sx={{mt: 2}}>

                {/* Status */}
                <Grid item sm={4}>
                    <CustomeTextField
                        label="Status"
                        attr="ProjectState"
                        type="select"
                        object={projectObject}
                        setObject={setProjectObject}
                        required
                    >
                        {projectStateArray.map((x) => (
                            <MenuItem key={`projectstate-${x.id}`} value={x.id}>
                                {x.projectState}
                            </MenuItem>
                        ))}
                    </CustomeTextField>
                </Grid>

                {/* Titel */}
                <Grid item sm={8}>
                    <CustomeTextField
                        label="Titel"
                        attr="title"
                        type="string"
                        object={projectObject}
                        setObject={setProjectObject}
                        required
                    />
                </Grid>

                {/* Projektstart */}
                <Grid item sm={6}>
                    <CustomeTextField
                        label="Projektstart"
                        attr="project_start"
                        type="date"
                        object={projectObject}
                        setObject={setProjectObject}
                        null
                    />
                </Grid>

                {/* Stornogrund rechts daneben */}
                <Grid item sm={6}>
                    <Collapse in={projectObject.ProjectState === 12}>
                        <CustomeTextField
                            label="Stornogrund"
                            attr="ReasonCancellation"
                            type="select"
                            object={projectObject}
                            setObject={setProjectObject}
                            required={projectObject.ProjectState === 12}
                            null
                        >
                            {reasonCancellationArray.map((x) => (
                                <MenuItem key={`reasonCancellation-${x.id}`} value={x.id}>
                                    {x.reasonCancellation}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    </Collapse>
                </Grid>
                {contactCustomerObject && (
                    <Grid item sm={6}>
                        <CustomeTextField
                            label="Leadquelle"
                            attr="LeadQuelle"
                            type="select"
                            object={contactCustomerObject}
                            setObject={(newCustomer: ICustomer) => {
                                setContactCustomerObject(newCustomer);
                                updateCustomerLeadQuelle(newCustomer); // siehe nächsten Schritt
                            }}
                        >
                            {leadQuellen?.map((quelle) => (
                                <MenuItem key={quelle.id} value={quelle.id}>
                                    {quelle.leadQuelle}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    </Grid>
                )}

                {/* Accordion für alle Termine */}
                <Grid item xs={12}>
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                            <Typography
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: hasErrors ? "error.main" : "inherit",
                                }}
                            >
                                Termine
                                {hasErrors && (
                                    <Typography component="span" variant="caption" color="error.main" sx={{ml: 1}}>
                                        Unvollständige Terminangaben
                                    </Typography>
                                )}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2}>
                                {/* 1. Anfrage */}
                                <Grid item sm={6}>
                                    <CustomeTextField
                                        label="Anfrage"
                                        attr="date_inquiry"
                                        type="date"
                                        object={projectObject}
                                        setObject={setProjectObject}
                                        null
                                        error={errors.inquiry}
                                        helperText={errors.inquiry ? "Bitte Termin angeben" : undefined}
                                    />
                                </Grid>

                                {/* 2. B-Termin */}
                                <Grid item sm={6}>
                                    <TextField
                                        type="datetime-local"
                                        variant="outlined"
                                        label="B-Termin"
                                        fullWidth
                                        size="small"
                                        value={b_appointmentDateTime}
                                        disabled
                                        error={errors.bTermin}
                                        helperText={errors.bTermin ? "Bitte Termin angeben" : undefined}
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {projectObject.id_b_appointment ? (
                                                        <IconButton
                                                            onClick={() =>
                                                                handleOpenCalendar(
                                                                    "b_appointment",
                                                                    projectObject.id_b_appointment
                                                                        ? parseInt(projectObject.id_b_appointment, 10)
                                                                        : undefined
                                                                )
                                                            }
                                                        >
                                                            <EditIcon/>
                                                        </IconButton>
                                                    ) : (
                                                        <IconButton onClick={() => handleOpenCalendar("b_appointment")}>
                                                            <AddIcon/>
                                                        </IconButton>
                                                    )}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>

                                {/* 3. Bautermin */}
                                <Grid item sm={6}>
                                    <TextField
                                        type="datetime-local"
                                        variant="outlined"
                                        label="Bautermin"
                                        fullWidth
                                        size="small"
                                        value={construction_appointmentDateTime}
                                        disabled
                                        error={errors.baubeginn}
                                        helperText={errors.baubeginn ? "Bitte Termin angeben" : undefined}
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {projectObject.id_construction_appointment ? (
                                                        <IconButton
                                                            onClick={() =>
                                                                handleOpenCalendar(
                                                                    "construction_appointment",
                                                                    projectObject.id_construction_appointment !== null
                                                                        ? parseInt(projectObject.id_construction_appointment, 10)
                                                                        : undefined
                                                                )
                                                            }
                                                        >
                                                            <EditIcon/>
                                                        </IconButton>
                                                    ) : (
                                                        <IconButton
                                                            onClick={() => handleOpenCalendar("construction_appointment")}>
                                                            <AddIcon/>
                                                        </IconButton>
                                                    )}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>

                                {/* 4. Abnahme */}
                                <Grid item sm={6}>
                                    <CustomeTextField
                                        label="Abnahme"
                                        attr="date_acceptance"
                                        type="date"
                                        object={projectObject}
                                        setObject={setProjectObject}
                                        null
                                        error={errors.abnahme}
                                        helperText={errors.abnahme ? "Bitte Termin angeben" : undefined}
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>

            <Grid sm={12}>
                <Collapse
                    in={
                        projectObject.Participant.find((x) => x.is_contact_person) !== undefined ||
                        projectObject.ConstructionSite !== null
                    }
                >
                    <MapSearch
                        key={`map-participant-${projectObject.Participant.find((x) => x.is_contact_person)?.id}`}
                        currentAddress={
                            projectObject.ConstructionSite !== null
                                ? projectObject.ConstructionSite
                                : customer.find(
                                    (y) =>
                                        y.id ===
                                        projectObject.Participant.find((x) => x.is_contact_person)?.Customer,
                                )?.b2b
                                    ? customer.find(
                                        (y) =>
                                            y.id ===
                                            projectObject.Participant.find((x) => x.is_contact_person)?.Customer,
                                    )?.Company?.Address
                                    : customer.find(
                                        (y) =>
                                            y.id ===
                                            projectObject.Participant.find((x) => x.is_contact_person)?.Customer,
                                    )?.Address
                        }
                    />
                </Collapse>
            </Grid>

            <Box sx={{width: "100%", mt: 5}}>
                <Box sx={{borderBottom: 1, borderColor: "divider"}}>

                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="basic tabs example"
                    >
                        <Tab label="Kunden" {...a11yProps(0)} />
                        <Tab label="Adressen" {...a11yProps(1)} />
                        <Tab label="Mitarbeiter" {...a11yProps(2)} />
                        <Tab label="Angebote" {...a11yProps(3)} />
                        <Tab label="Verträge" {...a11yProps(4)} />
                        <Tab label="Checklisten" {...a11yProps(5)} />
                        <Tab label="Übergabeprotokolle" {...a11yProps(6)} />
                        {[1, 2].includes(idRole) && <Tab label="Rechnungen" {...a11yProps(7)} />}
                        <Tab label="Dokumente" {...a11yProps(8)} />
                        <Tab label="Notizen" {...a11yProps(9)} />
                        <Tab label="Historie" {...a11yProps(10)} />
                    </Tabs>
                </Box>

                <CustomTabPanel value={value} index={0}>
                    <ParticipantsTable
                        genderArray={genderArray}
                        titleArray={academicTitleArray}
                        insuranceArray={insuranceArray}
                        setInsuranceArray={setInsuranceArray}
                        setPropertyManagementArray={setPropertyManagementArray}
                        addressTypeArray={addressTypeArray}
                        propertyManagementArray={propertyManagementArray}
                        projectObject={projectObject}
                        customerArray={customer}
                        setCustomerArray={setCustomer}
                        participants={projectObject.Participant}
                        setProjectObject={setProjectObject}
                        application={false}
                        assignWorkerForCustomer={assignWorkerForCustomer}
                    />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                    <AddressEdit projectObject={projectObject} setProjectObject={setProjectObject}/>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={2}>
                    <WorkerTable
                        projectObject={projectObject}
                        setProjectObject={setProjectObject}
                        userArray={userArray}
                        workerArray={projectObject.Worker}
                    />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={3}>
                    <OfferTable
                        projectObject={projectObject}
                        setProjectObject={setProjectObject}
                        offerArray={offers}
                        setOfferArray={(x: any) => refetechOfferByProject()}
                        reasonCancellationArray={reasonCancellationArray}
                        customerArray={customerArray}
                        offerStateArray={offerStateArray}
                        offerTypeArray={offerTypeArray}
                        templateArray={templateArray}
                        partnerArray={partnerArray}
                        serviceArray={serviceArray}
                        serviceCategoryArray={serviceCategoryArray}
                        materialArray={materialArray}
                        materialCategoryArray={materialCategoryArray}
                        materialSubcategoryArray={materialSubcategoryArray}
                        unitArray={unitArray}
                        materialDocumentArray={materialDocumentArray}
                        systemMailArray={systemMailArray}
                    />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={4}>
                    <ContractTab
                        project={projectObject}
                        contractStateArray={contractStateArray}
                        contractTypeArray={contractTypeArray}
                        offerArray={offers}
                        customerArray={customerArray}
                        partnerArray={partnerArray}
                        templateArray={templateArray}
                        serviceArray={serviceArray}
                        serviceCategoryArray={serviceCategoryArray}
                        unitArray={unitArray}
                        offerStateArray={offerStateArray}
                        offerTypeArray={offerTypeArray}
                    />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={5}>
                    <CheckListTab offerArray={offerArray} setOfferArray={setOfferArray}/>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={6}>
                    <HandoverProtocolTable
                        handoverProtocolArray={handoverProtocolArray || []}
                        setHandoverProtocolArray={setHandoverProtocolArray}
                        projectObject={projectObject}
                        setProjectObject={setProjectObject}
                        partnerArray={partnerArray}
                        unitArray={unitArray}
                        offerArray={offers || []}
                        offerStateArray={offerStateArray}
                        offerTypeArray={offerTypeArray}
                        customerArray={customerArray}
                        templateArray={templateArray}
                    />
                </CustomTabPanel>

                {[1, 2].includes(idRole) && (
                    <CustomTabPanel value={value} index={7}>
                        <InvoiceTab project={projectObject} invoiceStates={invoiceStates} invoiceTypes={invoiceTypes}/>
                    </CustomTabPanel>
                )}

                <CustomTabPanel value={value} index={8}>
                    <DocumentTable
                        projectObject={projectObject}
                        setProjectObject={setProjectObject}
                        isWorking={isDocumentsWorking}
                        setIsWorking={setIsDocumentsWorking}
                    />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={9}>
                    <ProjectNoteTable
                        projectId={projectObject.id}
                        userArray={userArray}
                        noteArray={projectObject.NoteArray}
                        setNoteArray={(newArray: IProjectNote) =>
                            setProjectObject({...projectObject, NoteArray: newArray})
                        }
                    />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={10}>
                    <ProjectLogTab project={projectObject}/>
                </CustomTabPanel>
            </Box>
        </>
    );
};
